document.addEventListener("DOMContentLoaded", function (){
  const SliderMUtiplyfBanners = document.querySelectorAll(".slider-mutiply-content");

  SliderMUtiplyfBanners.forEach((element) => {

  var larguraDaTela = window.innerWidth;
  if(larguraDaTela >= 600)
  $(`#${element.id}`).slick({
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 5,
      slidesToScroll: 1,

      prevArrow: `
      <button width="40px" height="40px" type="button" class="slick-prev">
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="13" viewBox="0 0 8 13" fill="none">
          <path d="M0.481401 6.73743C0.480264 6.62592 0.501655 6.51533 0.54429 6.41228C0.586924 6.30924 0.649925 6.21586 0.729517 6.13775L6.10599 0.967782C6.26529 0.824646 6.47092 0.743855 6.68505 0.740277C6.79656 0.739139 6.90716 0.760529 7.0102 0.803163C7.11325 0.845798 7.20662 0.908799 7.28473 0.988392C7.43602 1.14859 7.51858 1.36165 7.51473 1.58197C7.51087 1.80228 7.42092 2.01232 7.26412 2.16713L2.50793 6.73703L7.26412 11.3069C7.42316 11.4605 7.51468 11.671 7.51855 11.892C7.52241 12.1131 7.43831 12.3266 7.28473 12.4857C7.13115 12.6447 6.92068 12.7362 6.69963 12.7401C6.47857 12.744 6.26503 12.6599 6.10599 12.5063L0.729517 7.33711C0.649925 7.259 0.586924 7.16562 0.54429 7.06258C0.501655 6.95953 0.480264 6.84894 0.481401 6.73743Z" fill="#5E2B43"/>
        </svg>
      </button>`,
      nextArrow: `
      <button width="40px" height="40px" type="button" class="slick-next"> 
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="13" viewBox="0 0 8 13" fill="none">
          <path d="M7.51872 6.74304C7.51986 6.85455 7.49847 6.96514 7.45583 7.06818C7.4132 7.17123 7.3502 7.26461 7.27061 7.34271L1.89413 12.5127C1.73483 12.6558 1.5292 12.7366 1.31507 12.7402C1.20356 12.7413 1.09297 12.7199 0.989922 12.6773C0.886878 12.6347 0.793503 12.5717 0.715394 12.4921C0.564103 12.3319 0.481545 12.1188 0.485397 11.8985C0.489249 11.6782 0.579205 11.4681 0.736004 11.3133L5.49219 6.74343L0.736004 2.17353C0.57696 2.01996 0.485438 1.80949 0.481573 1.58843C0.477708 1.36737 0.561816 1.15384 0.715394 0.994792C0.868971 0.835748 1.07944 0.744227 1.3005 0.740362C1.52155 0.736497 1.73509 0.820604 1.89413 0.974182L7.27061 6.14336C7.3502 6.22147 7.4132 6.31485 7.45583 6.41789C7.49847 6.52094 7.51986 6.63153 7.51872 6.74304Z" fill="#5E2B43"/>
        </svg>
      </button>`,
    });
  })

})
